import React from "react";
import { Layout, Input, message, Row, Col, Spin } from "antd";
import Iconfont from "../../components/Iconfont/Iconfont";
import qiWenLogo from "../../assets/img/qiwenlogo.png";
import book from "../../assets/img/book.png";
import noneData from "../../components/noneData";
import API from "../../api";
import "./index.scss";
import {responseDataFilter} from "../../utils/tool";

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            recommendList: [],
            searchValue: "",
            isSearchStatus: false,
            pageNum: 1,
            isHaveData: true,
            isMobile: window.screen.width < 500,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.getRecommendList();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    async getRecommendList() {
        const res = await API.Book.getRecommendBookList();
        const resData = responseDataFilter(res);
        if (resData) {
            this.setState({
                recommendList: resData,
            })
        }
    }

    async searchBook () {
        const {pageNum, bookName} = this.state;
        const res = await API.Book.getRecommendBookList({
            data: {
                pageNum,
                bookName,
            },
            loading: true,
            loadingText: "书籍加载中...",
        });
        const resData = responseDataFilter(res);
        if (resData) {
            this.setState({
                dataList: resData,
            })
        }
    }

    handleResize = () => {
        this.setState({
            isMobile: document.documentElement.clientWidth < 500,
        });
    }

    toReadPage (bookId) {
        if(this.state.isMobile) {
            window.historyInstance.push(`/page/read?bookId=${bookId}`);
        } else if (window.historyInstance) {
            window.open(`/page/read?bookId=${bookId}`, "_blank");
        }
    }

    async searchFunc() {
        const {searchValue} = this.state;
        if (searchValue) {
            const {pageNum} = this.state;
            const res = await API.Book.searchBookList({
                data: {
                    pageNum,
                    bookName: searchValue,
                },
                loading: true,
                loadingText: "书籍加载中...",
            });
            const resData = responseDataFilter(res);
            if (resData) {
                this.setState({
                    dataList: resData,
                    isSearchStatus: true,
                    isHaveData: resData.length > 0,
                })
            }
        } else {
            message.warning("请输入小说名称");
        }
    }

    handleScroll (e) {
        const {isSearchStatus, pageNum, isHaveData} = this.state;
        const {scrollTop, clientHeight, scrollHeight} = e.target;
        const marginBottom = scrollHeight - scrollTop - clientHeight;
        if (isHaveData && isSearchStatus && marginBottom < 100) {
            this.setState({
                pageNum: pageNum + 1,
            },() => {
                this.searchFunc();
            });
        }
    }

    render() {
        const {dataList, recommendList, searchValue, isMobile, isSearchStatus} = this.state;
        if(recommendList.length > 5) {
            for(let i = recommendList.length; i < 10; i++) {
                recommendList.push({})
            }
        }
        return (
            <div className={`searchFrame ${isMobile ? "mobileStatus" : ""} ${isSearchStatus ? "searchStatus" : ""}`}>
                {/* logo */}
                <div className="logoBox">
                    <img src={qiWenLogo} alt="logo" className="logo"/>
                </div>
                {/* 搜索框 */}
                <div className="searchBox">
                    <Input
                        className="inputBox"
                        value={searchValue}
                        placeholder="请输入小说名称，宁少字，不错字"
                        maxLength={30}
                        onBlur={(e) => {
                            let value = e.target.value;
                            if(!value) {
                                this.setState({
                                    isSearchStatus: false,
                                    dataList: [],
                                    pageNum: 1,
                                    isHaveData: true, // 是否有数据
                                })
                            }
                        }}
                        onChange={(e) => this.setState({searchValue: e.target.value})}
                        onPressEnter={() => this.searchFunc()}
                    />
                    <span className="searchBtn" onClick={() => this.searchFunc()}>奇文一下</span>
                </div>

                {/* 搜索结果 */}
                {
                    isSearchStatus ?
                        (
                            <div className="searchResult">
                                <div
                                    className="scrollBox"
                                    onScroll={(e) => {
                                        this.handleScroll(e)
                                    }}
                                >
                                    {
                                        dataList.length > 0 ?
                                            (
                                                <React.Fragment>
                                                    {
                                                        dataList.map((item, index) => {
                                                            return (
                                                                <div className="articleItem" key={index} onClick={() => this.toReadPage(item.id)}>
                                                                    <div className="articleImgBox">
                                                                        <img src={item.bookImg || book} alt="" />
                                                                    </div>
                                                                    <div className="articleInfoBox">
                                                                        <span className="articleTitle overflowEllipsis" title={item.bookName}>{item.bookName}</span>
                                                                        <span className="articleDesc" title={item.intro}>{item.intro}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    <div className="bottomTipBox">
                                                        <span className="tipText">亲，已经到底了哦~</span>
                                                    </div>
                                                </React.Fragment>
                                            )
                                            :
                                            (noneData("暂时没有符合搜索条件的小说"))
                                    }
                                </div>
                            </div>
                        )
                        :
                        (
                            <div className="recommendListBox">
                                {
                                    recommendList.length > 0 ?
                                        (
                                            recommendList.map((item, index) => {
                                                if (!item.id) {
                                                    return <div className="zhanwei"></div>
                                                }
                                                return (
                                                    <div className="recommendItem" key={index}>
                                                        <img src={item.bookImg || book} alt="" onClick={() => this.toReadPage(item.id)}/>
                                                    </div>
                                                )
                                            })
                                        )
                                        :
                                        (noneData("暂无推荐内容"))

                                }
                            </div>
                        )
                }

            </div>
        )
    }
}

export default Search;
